import {gsap} from "gsap";
import {ScrollToPlugin} from "gsap/ScrollToPlugin";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);


jQuery(document).ready(() => {
	function gsapParallax() {
		gsap.utils.toArray(".section-parallax").forEach((section, i) => {
			section.bg = section.querySelector(".parallax-content");

			// Do the parallax effect on each section
			if (i) {
				section.bg.style.backgroundPosition = `50% ${-innerHeight / 2}px`;

				gsap.to(section.bg, {
					backgroundPosition: `50% ${innerHeight / 2}px`,
					ease: "none",
					scrollTrigger: {
						trigger: section,
						scrub: true,
					},
				});
			}

			// the first image should be positioned against the top. Use px on the animating part to work with GSAP.
			else {
				section.bg.style.backgroundPosition = "50% 0px";

				gsap.to(section.bg, {
					backgroundPosition: `50% ${innerHeight / 3}px`,
					ease: "none",
					scrollTrigger: {
						trigger: section,
						start: "top top",
						end: "bottom top",
						scrub: true,
					},
				});
			}
		});
	}

	gsapParallax();

	//fadein icon
	function fadeinEl() {
		const bgEl = document.querySelector('.ck_block_bg');
		const featuredEl = document.querySelector('.featured-items');

		gsap.set(bgEl, {
			opacity: 0,
		});

		const tl = gsap.timeline({

			scrollTrigger: {
				trigger: bgEl,
				start: "top 40%",
				end: "bottom 50%",
				scrub: true,
				// markers: true,
				toggleActions: "play reverse play reverse",
			},
		});

		tl
			.to(bgEl, {opacity: 1, duration: 0.5})
			.to(bgEl, {opacity: 0, duration: 0.5})
			.set(featuredEl, {opacity: 1});
	}

	fadeinEl();

	//fixed sections
	function fixedEl() {
		ScrollTrigger.matchMedia({

			// desktop
			"(min-width: 1200px)": function () {
				gsap.utils.toArray(".panel-fixed").forEach((elem) => {
					gsap.to(elem, {
						scrollTrigger: {
							trigger: elem,
							pin: true,
							pinSpacing: false,
							scrub: true,
							start: "top 120px",
							end: "+=200%",
							// markers: {startColor: "red", endColor: "purlpe"},
						},
					});
				});
				gsap.set(".panel-fixed", {zIndex: (i, target, targets) => targets.length - i});
			},
		});
	}

	fixedEl();

	//featured procedures
	function featuredItems() {
		ScrollTrigger.matchMedia({

			// desktop
			"(min-width: 1200px)": function () {
				const overlayEl = document.querySelector('.featured-items__title');
				const elBtn = document.querySelectorAll('.featured-block__btn');
				const gridElBg = document.querySelectorAll('.featured-block-bg');
				const gridElOverlay = document.querySelectorAll('.featured-block-overlay');
				const gridEl = document.querySelectorAll('.featured-block');
				gsap.set(overlayEl, {'opacity': 0.01});
				gsap.set(gridElBg, {'filter': 'grayscale(100%) contrast(120%) brightness(85%) opacity(92%)'});
				gsap.set(elBtn, {'opacity': 0});

				const tlOverlay = gsap.timeline({
					scrollTrigger: {
						trigger: '.featured-items',
						pin: false,
						scrub: true,
						pinSpacing: false,
						start: "top 40%",
						end: 'top top',
						// markers: true,
					},
				});

				tlOverlay
					.to(gridElOverlay, {opacity: 0, duration: 1})
					.set(gridElBg, {opacity: 0.93}, '-=0.5')

				const tl = gsap.timeline({
					scrollTrigger: {
						trigger: '.featured-items',
						pin: false,
						scrub: true,
						pinSpacing: false,
						start: "top 120px",
						end: 'bottom bottom',
						// markers: true,
					},

				});

				tl
					.to('.featured-items__wrap', {zIndex: 0})
					.to(overlayEl, {opacity: 1, duration: 1})
					.to(overlayEl, {opacity: 0, duration: 1, pointerEvents: 'none'}, '+=1')
					.to('.featured-block__list', {opacity: 1, duration: 1}, '-=1')
					.to(elBtn, {opacity: 1, duration: 1}, '-=1')
					.to(gridElBg, {filter: 'grayscale(0%)', duration: 1}, '-=1')
					.set(gridElBg, {opacity: 1}, '-=0.5')
					.set(gridEl, {css: {zIndex: 6}})
					.to({}, {duration: 2})
			},
		});

	}

	featuredItems();
});



// WEBPACK FOOTER //
// ./scripts/modules/animations.js